import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LoadingController, AlertController } from '@ionic/angular';
import { AuthService } from '../../services/user/auth.service';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import { Router } from '@angular/router';
import { trigger, style, animate, transition } from '@angular/animations';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(900, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ResetPasswordPage implements OnInit {
  public resetForm: FormGroup;
  public tokenForm: FormGroup;
  public loading: HTMLIonLoadingElement;
  mostraFormToken = false;
  public showPassword: boolean = false;
  alertaDominio = false
  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private authService: AuthService,
    private passaObjetoService: PassaObjetoService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    this.resetForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
    });
    this.tokenForm = this.formBuilder.group({
      token: ['', Validators.compose([Validators.required, , Validators.minLength(6)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  ngOnInit() {
    this.resetForm.get("email").valueChanges.subscribe(email => {
      function getSecondPart(str) {
        return str.split('@')[1];
      }
      // use the function:
      let dominio = getSecondPart(email)
      if (dominio === 'mprj.mp.br') {
        this.alertaDominio = true
      } else {
        this.alertaDominio = false
      }
    })
  }
  async chamaAlerta(message, buttons) {
    const alert = await this.alertCtrl.create({
      message,
      buttons
    });
    await alert.present();
  }

  public onPasswordToggle(): void {
    this.showPassword = !this.showPassword;
  }
  public toggleMostraFormToken(): void {
    this.mostraFormToken = !this.mostraFormToken;
  }
  async resetPassword(emailForm: FormGroup) {
    let _self = this
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    let userEmail = this.resetForm.value.email;
    // console.log("userEmail", userEmail)

    this.authService.resetPassword(userEmail)
      .subscribe(
        res => {
          // console.log('HTTP response', res)
          this.loading.dismiss().then(() => {
            _self.mostraFormToken = true
          });

        },
        err => {
          // console.log('HTTP Error', err)
          if (err.error.status == "USUARIO NÃO HBILITADO NO SISTEMA"){
            this.loading.dismiss().then(() => {
              this.passaObjetoService.navParams = {userObj: userEmail}
              this.router.navigate(['/login/confirmacao']);
            });
           
          }else {
          this.loading.dismiss().then(() => {
            let message = "Houve uma falha no envio.  Por favor, confira se o e-mail digitado está correto"
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
          });
        }
        },
        () => this.loading.dismiss()
      );
  }



  async updatePassword(tokenForm: FormGroup) {
    let _self = this
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    let pwd = tokenForm.value.password;
    let token = tokenForm.value.token;
    // console.log("pwd", pwd, "token", token)
    this.authService.updatePassword(pwd, token)
      .subscribe(
        res => {
          // console.log('HTTP response', res)
          if (res['cod'] === 200) {
            this.loading.dismiss().then(() => {
              _self.mostraFormToken = true
              let message = "Sua senha foi alterada com sucesso.  Clique em OK para realizar seu login"
              let buttons = [{
                text: 'Ok', handler: (d) => {
                  let userObj = {
                    email: this.resetForm.value.email,
                    password: tokenForm.value.password
                  }
                  this.authService.loginUsuario(userObj).subscribe(
                    res => {
                      // console.log('HTTP response', res)
                      if (res['cod'] == 200) {


                        this.loading.dismiss().then(() => {
                          // this.authService.getUserData()
                          window.location.reload()
                          // this.router.navigateByUrl('/novo-saude');
                        });
                      }

                    },
                    err => {
                      // console.log('HTTP Error', err)
                      if (err.status == 400) {
                        this.loading.dismiss().then(() => {
                          let message = "Falha no login. Por favor, confira seus dados tente novamente em alguns minutos."
                          let buttons = [{ text: 'Ok', role: 'cancel' }]
                          this.chamaAlerta(message, buttons)
                          this.router.navigateByUrl('/login');
                        });
                      }
                      if (err.status == 500) {
                        this.loading.dismiss().then(() => {
                          let message = "Falha no login. Por favor, confira seus dados tente novamente em alguns minutos."
                          let buttons = [{ text: 'Ok', role: 'cancel' }]
                          this.chamaAlerta(message, buttons)
                          this.router.navigateByUrl('/login');
                        });
                      }
                    },
                    () => this.loading.dismiss()
                  );

                }
              }]
              this.chamaAlerta(message, buttons)
            });
          } else {
            this.loading.dismiss().then(() => {
              let message = "Houve uma falha no envio.  Por favor, confira se o código digitado está correto"
              let buttons = [{ text: 'Ok', role: 'cancel' }]
              this.chamaAlerta(message, buttons)
            });
          }

        },
        err => {
          // console.log('HTTP Error', err)
          this.loading.dismiss().then(() => {
            let message = "Houve uma falha no envio.  Por favor, confira se o código digitado está correto"
            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
          });
        },
        () => this.loading.dismiss()
      );





  }
}
